import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { event } from '../../../store/selectors/event';
import { updateEvent } from '../../../store/actions/event';

const withEdit = Component => {
  const Composed = ({ event, updateEvent, ...props }) => {
    return (
      <Component
        {...props}
        title="Update event"
        saveButtonTitle="Update"
        event={event}
        action={updateEvent}
      />
    );
  };

  const mapStateToProps = state => ({
    event: event(state),
  });

  Composed.propTypes = {
    event: PropTypes.shape({}),
    updateEvent: PropTypes.func.isRequired,
  };

  Composed.defaultProps = {
    event: null,
  };

  return connect(mapStateToProps, { updateEvent })(Composed);
};

export default withEdit;
